<template>
	<template v-if="visible">
		<template v-if="editMode">
			<span class="pos-label app-label">{{ rf.label }}:</span>
			<span class="pos-field app-field" style="column-gap: var(--input-spacing)">
				<suggester-part :data="localData" :part="rf.edit" :readonly="ro" :viewmode="vm" @suggested="goViewMode" :data-index="index"></suggester-part>
				<icon-button v-if="isRefering" name="eye" @click="editMode = false"></icon-button>
				<icon-button v-else-if="!rf.keep" name="close" @click="emit('hide')"></icon-button>
			</span>
		</template>
		<reference-header-part v-else :data="localData" :part="rf.view" :readonly="ro" :viewmode="vm" class="pos-wide" @edit="goEditMode"></reference-header-part>
	</template>
</template>

<script setup lang="ts">
import {ref, computed, onMounted} from "vue";
import useContainer, {ContainerProps} from "@fd/containers/Container.ts";
import {Reference} from "@t/fd/editor/References.ts";
import {injectMaskingLib} from "@fd/Masking.ts";
import ReferenceHeaderPart from "@fd/editors/reference/ReferenceHeaderPart.vue";
import SuggesterPart from "@fd/editors/suggester/SuggesterPart.vue";
import IconButton from "@fd/helpers/IconButton.vue";

interface ReferenceProps extends ContainerProps {
	index: number;
}

const emit = defineEmits(['hide']);
const props = defineProps<ReferenceProps>();
const {visible, localData, ro, vm, clazz, style} = useContainer(props);
const rf = computed<Reference>(() => props.part as Reference);
const mlib = injectMaskingLib();

const editMode = ref<boolean>(true);

const isRefering = computed<boolean>(() => {
	let empty: boolean;
	if (rf.value.test) empty = mlib.evaluateTest(localData.value, vm.value, rf.value.test);
	else empty = false;
	return !empty;
});

function goEditMode(): void {
	if (!ro.value && !vm.value) editMode.value = true;
}

function goViewMode(): void {
	editMode.value = false;
}

onMounted(() => {
	editMode.value = !isRefering.value && !ro.value && !vm.value;
});
</script>

<style>

</style>